import { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
const T = { bg:'#f0f5e8', cream:'#fffef0', greenDk:'#1b5e20', maroon:'#6d1b1b', orange:'#e65100', border:'#c8e6c9', header:'linear-gradient(135deg,#090b72,#1a237e)' };
const WDAYS = ['ஞா','தி','செ','பு','வி','வெ','ச'];
const EMONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

// Special day icons
const getIcon = (sp) => {
  if (!sp) return '';
  if (sp.includes('அமாவாசை')) return '🌑';
  if (sp.includes('பௌர்ணமி')) return '🌕';
  if (sp.includes('ஏகாதசி')) return '🙏';
  if (sp.includes('சதுர்த்தி')) return '🐘';
  if (sp.includes('ஷஷ்டி')) return '🔱';
  if (sp.includes('கிருத்திகை')) return '🔥';
  if (sp.includes('ப்ரதோஷ')) return '🕉️';
  if (sp.includes('சங்கடஹர')) return '🐘';
  if (sp.includes('வைத்ருதி')||sp.includes('வ்யதீபாத')) return '⚠️';
  if (sp.includes('விஷ்ணுபதி')) return '🔷';
  if (sp.includes('விஷு')) return '🔶';
  return '⭐';
};

const MonthlyPage = () => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth());
  const [allData, setAllData] = useState([]);
  const [sel, setSel] = useState(null);

  useEffect(() => {
    axios.get('/data/panchangam_data-2025-to-2028.json').then(r => setAllData(r.data)).catch(() => {});
  }, []);

  const dayMap = useMemo(() => {
    const m = {};
    allData.forEach(d => {
      const p = d.EnglishDate.split('/');
      const key = `${p[2]}-${String(parseInt(p[0])).padStart(2,'0')}-${String(parseInt(p[1])).padStart(2,'0')}`;
      m[key] = d;
    });
    return m;
  }, [allData]);

  // Build calendar grid
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const weeks = [];
  let week = new Array(firstDay).fill(null);
  for (let d = 1; d <= daysInMonth; d++) {
    week.push(d);
    if (week.length === 7) { weeks.push(week); week = []; }
  }
  if (week.length > 0) { while (week.length < 7) week.push(null); weeks.push(week); }

  const getKey = (d) => `${year}-${String(month+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
  const prevMonth = () => { if (month === 0) { setMonth(11); setYear(year-1); } else setMonth(month-1); setSel(null); };
  const nextMonth = () => { if (month === 11) { setMonth(0); setYear(year+1); } else setMonth(month+1); setSel(null); };
  const isToday = (d) => { const t=new Date(); return d===t.getDate() && month===t.getMonth() && year===t.getFullYear(); };

  const selData = sel ? dayMap[getKey(sel)] : null;
  const fmt = v => v != null ? Number(v).toFixed(2) : '';

  return (
    <div style={{background:T.bg,minHeight:'80vh',padding:'10px'}}>
      {/* Header */}
      <div style={{background:T.header,padding:'12px',borderRadius:'10px',textAlign:'center',marginBottom:'10px'}}>
        <h1 style={{color:'#fff',margin:0,fontSize:'1rem',fontWeight:900}}>📅 மாத காலண்டர்</h1>
        <div style={{color:'#c8e6c9',fontSize:'0.7rem'}}>Monthly Calendar with Events</div>
      </div>

      {/* Month nav */}
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'10px',background:'#fff',borderRadius:'10px',padding:'8px 12px',border:'1px solid '+T.border}}>
        <button onClick={prevMonth} style={{border:'none',background:T.greenDk,color:'#fff',borderRadius:'50%',width:'32px',height:'32px',cursor:'pointer',fontSize:'1rem'}}>◀</button>
        <div style={{textAlign:'center'}}>
          <div style={{fontWeight:900,fontSize:'1.1rem',color:T.greenDk}}>{EMONTHS[month]} {year}</div>
        </div>
        <button onClick={nextMonth} style={{border:'none',background:T.greenDk,color:'#fff',borderRadius:'50%',width:'32px',height:'32px',cursor:'pointer',fontSize:'1rem'}}>▶</button>
      </div>

      {/* Calendar grid */}
      <div style={{background:'#fff',borderRadius:'10px',overflow:'hidden',border:'2px solid '+T.greenDk,marginBottom:'10px'}}>
        {/* Day headers */}
        <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',background:T.greenDk}}>
          {WDAYS.map((w,i) => (
            <div key={i} style={{textAlign:'center',padding:'6px 0',color:i===0?'#ffcdd2':'#fff',fontSize:'0.7rem',fontWeight:700}}>{w}</div>
          ))}
        </div>
        {/* Weeks */}
        {weeks.map((wk,wi) => (
          <div key={wi} style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)'}}>
            {wk.map((d,di) => {
              if (!d) return <div key={di} style={{minHeight:'55px',background:'#fafafa',border:'1px solid #f0f0f0'}} />;
              const pd = dayMap[getKey(d)];
              const sp = pd?.DaySpecialityInTamil;
              const icon = getIcon(sp);
              const isSun = di === 0;
              const selected = sel === d;
              return (
                <div key={di} onClick={() => setSel(sel===d?null:d)} style={{
                  minHeight:'55px',padding:'2px',cursor:'pointer',border:'1px solid #eee',
                  background: selected ? '#e8f5e9' : isToday(d) ? '#fff8e1' : '#fff',
                  transition:'all 0.15s',position:'relative'
                }}>
                  <div style={{fontSize:'0.8rem',fontWeight:isToday(d)?900:600,color:isSun?'#c62828':T.greenDk,textAlign:'right',paddingRight:'3px'}}>
                    {d}
                  </div>
                  {pd && <div style={{fontSize:'0.45rem',color:T.maroon,textAlign:'center',lineHeight:1.2}}>
                    {pd.TamilDate}
                  </div>}
                  {pd && <div style={{fontSize:'0.4rem',color:'#555',textAlign:'center',overflow:'hidden',whiteSpace:'nowrap'}}>
                    {pd.NakshatraNameInTamil?.substring(0,4)}
                  </div>}
                  {icon && <div style={{position:'absolute',bottom:'1px',left:'1px',fontSize:'0.7rem'}} title={sp}>{icon}</div>}
                  {isToday(d) && <div style={{position:'absolute',top:'1px',left:'1px',width:'5px',height:'5px',borderRadius:'50%',background:'#ff9800'}} />}
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {/* Legend */}
      <div style={{display:'flex',flexWrap:'wrap',gap:'6px',marginBottom:'10px',fontSize:'0.55rem',color:'#555'}}>
        {[['🌑','அமாவாசை'],['🌕','பௌர்ணமி'],['🙏','ஏகாதசி'],['🐘','சதுர்த்தி/சங்கடஹர'],['🔱','ஷஷ்டி'],['🔥','கிருத்திகை'],['🕉️','ப்ரதோஷம்'],['⚠️','தோஷம்']].map(([i,l]) => (
          <span key={l} style={{background:'#fff',padding:'2px 6px',borderRadius:'4px',border:'1px solid #eee'}}>{i} {l}</span>
        ))}
      </div>

      {/* Selected date detail */}
      {selData && (
        <div style={{background:T.cream,borderRadius:'10px',padding:'12px',border:'2px solid '+T.greenDk,animation:'fadeIn 0.2s'}}>
          <div style={{fontWeight:900,fontSize:'1rem',color:T.greenDk,marginBottom:'8px',textAlign:'center'}}>
            {sel}-{String(month+1).padStart(2,'0')}-{year} — {selData.DayNameInTamil}
          </div>
          <div style={{fontSize:'0.75rem',textAlign:'center',color:T.maroon,marginBottom:'10px'}}>
            {selData.YearNameInTamil} • {selData.TamilMonth}-{selData.TamilDate}
          </div>
          {/* Detail grid */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'6px',fontSize:'0.7rem'}}>
            {[
              ['🌙 திதி', `${selData.ThithiNameInTamil} (${fmt(selData.ThithiDuration)})`],
              ['⭐ நக்ஷத்ரம்', `${selData.NakshatraNameInTamil} (${fmt(selData.NakshatraDuration)})`],
              ['🔄 யோகம்', selData.YogaNameInTamil],
              ['📐 கரணம்', selData.KaranamNameInTamil],
              ['☀️ சூர்யோதயம்', fmt(selData.SuryaUdhayam)],
              ['🌅 சூர்யாஸ்தமனம்', fmt(selData.SuryaAsthamanam)],
              ['📿 ராசி', selData.RaasiNameInTamil || '—'],
              ['🔮 பக்ஷம்', selData.PakshamNameInTamil],
            ].map(([label, val]) => (
              <div key={label} style={{background:'#fff',padding:'6px 8px',borderRadius:'6px',border:'1px solid #eee'}}>
                <div style={{fontSize:'0.6rem',color:'#888'}}>{label}</div>
                <div style={{fontWeight:700,color:T.greenDk}}>{val}</div>
              </div>
            ))}
          </div>
          {/* Special */}
          {selData.DaySpecialityInTamil && (
            <div style={{marginTop:'8px',background:'#fff3e0',padding:'8px',borderRadius:'6px',textAlign:'center',fontSize:'0.8rem',fontWeight:700,color:T.orange}}>
              ⭐ {selData.DaySpecialityInTamil}
            </div>
          )}
          {/* Shradhdha */}
          {selData.ShraadhdhaThithiNameInTamil && (
            <div style={{marginTop:'6px',background:'#f3e5f5',padding:'6px',borderRadius:'6px',textAlign:'center',fontSize:'0.7rem',color:'#6a1b9a',fontWeight:600}}>
              🙏 ச்ராத்த திதி: {selData.ShraadhdhaThithiNameInTamil}
            </div>
          )}
        </div>
      )}
      <style>{`@keyframes fadeIn { from{opacity:0;transform:translateY(-10px)} to{opacity:1;transform:translateY(0)} }`}</style>
    </div>
  );
};
export default MonthlyPage;